<script setup>
import {computed, defineEmits, defineProps, onMounted, ref, toRefs} from 'vue'
import axios from "axios";
import StarsComponent from "@/components/Base/StarsComponent.vue";
import CriterionLine from "@/views/ToExpert/CriterionLine.vue";
import {Modal, Spin} from "ant-design-vue";
import HoldOnIcon from "@/components/Icons/HoldOnIcon.vue";
import competitionServices from "@/services/competitionServices";

let modal_visible = ref(false);
let modal_success = ref(false);

let generalComment = ref('');

let isLoading = ref(false);

const props = defineProps({
  isDataUpdating: {
    type: Boolean
  },
  projectInfo: {},
  project: {},
});
const {isDataUpdating, project, projectInfo} = toRefs(props);

const emit = defineEmits(['toggleFavorite', 'addToFavorite'])

function toggleFavorite() {
  emit('toggleFavorite')
}


let voteCriterions = ref([]);

async function getVoteCriterions() {
  isLoading.value = true;
  const response = await axios.get('/project/get_vote_criterias_with_score/' + projectInfoId.value + '/' + tour.value);
  voteCriterions.value = response.data.voteCriterions;
  generalComment.value = response.data.generalComment;
  isLoading.value = false;
}

onMounted(() => {
  getVoteCriterions();
})


const disable_user_vote = computed(() => {
  return window.disable_user_vote;
})

const projectInfoId = computed(() => {
  return window.projectInfoId;
})

const tour = computed(() => {
  return window.tour;
})

const isSummaryGrade = computed(() => {
	return competitionServices.isSummaryGrade(projectInfo.value?.competition?.id);
})

const totalScore = computed(() => {
	// Проверяем, указаны ли все оценки
	let hasNotSelected = false;
	let hasStars = false;
	let countEls = 0;
	let normalizedSum = 0;
	let totalSum = 0;
	
	votes.value.forEach(vote => {
		if (vote.type === 'stars') {
			hasStars = true;
			countEls++;
			if (vote.value === undefined || vote.value === null || vote.value === 0) {
				hasNotSelected = true;
			}
		}
	})
	
	if (!hasStars) {
		return '_';
	}
	
	//Если все пункты отмечены
	if (!hasNotSelected) {
		
		voteCriterions.value.forEach((criterion, index) => {
			if (votes.value[index].type === 'stars') {
				const maxScale = criterion.gradingScale || 10; // По умолчанию 10-балльная шкала
				// Нормализуем оценку к процентам от максимума
				const normalizedValue = votes.value[index].value / maxScale;
				normalizedSum += normalizedValue;
				totalSum = totalSum + votes.value[index].value;
			}
		});
		if (isSummaryGrade.value) {
			return totalSum;
		}
		
		// Возвращаем среднее нормализованных значений, умноженное на 10 для 10-балльной шкалы результата
		return ((normalizedSum / countEls) * 10).toFixed(1);
	}
	
	return '-';
});

const votes = computed(() => {
  let res = [];
  voteCriterions.value.forEach(criterion => {
    res.push(
      {
        value: criterion.criterion_vote,
        type: criterion.customAnswers && criterion.customAnswers.length > 0 ? 'text' : 'stars',
        criterionId: criterion.id,
        comment: criterion.criterion_comment
      }
    );
  });
  return res;
})

const votes_filled = computed(() => {
  let res = true;
  votes.value.forEach(vote => {
    if (vote.value === undefined || vote.value === null || vote.value === 0) {
      res = false;
    }
  });
  return res;
})


async function addNewVote() {
  isDataUpdating.value = true;
  // || (projectInfo.value && projectInfo.value.competition && projectInfo.value.competition.id === 112) Чтобы разрешало голосить не проставив все оценки
	await axios.post('/add_new_vote', null, {
		params: {
			tour: tour.value,
			projectInfoId: projectInfoId.value,
			generalComment: generalComment.value,
			votes: votes.value,
		}
	}).catch((error) => {
		alert('Ошибка сохранения');
	})
	
	// if (votes_filled.value) {} else {
  //   modal_visible.value = true;
  //   return;
  // }
  modal_success.value = true;
  isDataUpdating.value = false;
}

function addToFavorite() {
  emit('addToFavorite')
}

</script>

<template>
    <div v-if="!disable_user_vote">
				<template v-if="!isLoading">
            <template v-if="voteCriterions.length > 0">
                <div class="gray_box scores_box">

                    <div class="criterions__wrapper">
                        <template v-for="(criterion,index) in voteCriterions" :key="criterion.id">
                            <CriterionLine
                                    v-model:criterion_vote="criterion.criterion_vote"
																		v-model:criterion_comment="criterion.criterion_comment"
                                    :criterion="criterion"
																		:criterion_index="index"
                            ></CriterionLine>

                        </template>
                    </div>
                    <div class="total_score_block" v-if="totalScore !== '_' && voteCriterions.length > 1">
                        <span class="total_score_block_text">Общая оценка проекта:</span>
                        <span class="total_score_block_result" v-if="isSummaryGrade">{{ totalScore }}</span>
                        <span class="total_score_block_result" v-else>{{ totalScore }} из 10</span>
                    </div>
<!--                    <div class="field your_score_text_field">-->
<!--                        <textarea :disabled="isDataUpdating"-->
<!--                                  placeholder="Ваш комментарий"-->
<!--                                  v-model="generalComment"-->
<!--                        ></textarea>-->
<!--                    </div>-->
                    <div class="columns your_score_text_footer">
                        <div class="column your_score_text_footer_col1 is-8 is-mobile-12">
                            <div class="as_favorite">Отметить проект как фаворит
                                <svg v-if="!project.is_favorite" @click="toggleFavorite" width="22" height="20"
                                     viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.71272 12.3473L0.551444 7.918C0.501111 7.87189 0.490867 7.81361 0.50745 7.7654L0.508 7.76379C0.525296 7.71293 0.580365 7.65779 0.668371 7.64655L7.57747 6.94709L7.85963 6.91852L7.97991 6.6617L10.8159 0.606292L10.8162 0.605644C10.8416 0.55124 10.9088 0.5 11 0.5C11.0912 0.5 11.1584 0.551248 11.1838 0.605626L11.1842 0.606549L14.0202 6.65303L14.1406 6.90962L14.4225 6.93816L21.3316 7.63762C21.4197 7.64887 21.4747 7.70401 21.492 7.75483L21.4927 7.75701C21.5092 7.80466 21.4986 7.86462 21.4464 7.91107L21.2792 8.05961L21.2791 8.06358L16.2944 12.3475L16.0671 12.5429L16.1323 12.8355L17.5749 19.3081C17.575 19.3082 17.575 19.3082 17.575 19.3083C17.5856 19.3569 17.5684 19.4188 17.5057 19.4621L17.7899 19.8735L17.506 19.4619C17.4397 19.5077 17.3464 19.5131 17.2736 19.4733L17.2735 19.4732L11.2398 16.1756L10.9998 16.0445L10.76 16.1757L4.73382 19.4733C4.66172 19.5127 4.56849 19.5081 4.50062 19.462C4.4391 19.4188 4.42186 19.357 4.4324 19.3085C4.43243 19.3083 4.43246 19.3082 4.43249 19.3081L5.87513 12.8355L5.94039 12.5426L5.71272 12.3473Z"
                                          stroke="#1D232D" stroke-opacity="0.5"/>
                                </svg>
                                <svg v-else @click="toggleFavorite" width="22" height="20" viewBox="0 0 22 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M21.7784 8.29378L16.6203 12.7267L18.0632 19.2004C18.1196 19.4561 18.0125 19.7198 17.7899 19.8735C17.5682 20.0264 17.2723 20.0425 17.0337 19.912L11 16.6144L4.97376 19.912C4.73516 20.0425 4.43925 20.0264 4.21663 19.8735C3.99494 19.7198 3.88785 19.4561 3.94422 19.2004L5.3871 12.7267L0.221564 8.29378C0.0233547 8.11768 -0.0499151 7.84861 0.0346285 7.60279C0.118234 7.35697 0.344633 7.18085 0.613275 7.14957L7.52711 6.44963L10.3631 0.394227C10.4749 0.154652 10.7248 0 11 0C11.2752 0 11.5251 0.154647 11.6369 0.394227L14.4729 6.44071L21.3867 7.14064C21.6554 7.17193 21.8818 7.34803 21.9654 7.59387C22.0499 7.8388 21.9766 8.10876 21.7784 8.28486L21.7784 8.29378Z"
                                          fill="url(#paint0_linear_2218_40)"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_2218_40" x1="0" y1="0" x2="22.7793" y2="0.930898"
                                                        gradientUnits="userSpaceOnUse">
                                            <stop offset="0.0001" stop-color="#F7C100"/>
                                            <stop offset="1" stop-color="#F69400"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
														<div class="otlozhit">
																Отложить проект
                                <HoldOnIcon
																				:is-active="project.is_isbrannoe"
																				@add-to-favorite="addToFavorite"
																/>
														</div>
                        </div>
                        <div class="column your_score_text_footer_col2">
                            <div>
                                <button v-if="!isDataUpdating" class="button4" @click="addNewVote">Отправить</button>
                                <Spin v-else></Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="gray_box" style="margin-bottom: 10px;">
                    <div class="columns score_header">
                        <div class="column score_header_left">
                            <div class="your_score_text"><span class="your_score_text_inner">Ваша оценка:</span>
                                <StarsComponent v-model="stars"></StarsComponent>
                            </div>
                        </div>
                        <div class="column is-narrow score_header_right">
                            <span class="score_header_right_text">8 баллов из 10</span>
                        </div>
                    </div>

<!--                    <div class="field your_score_text_field">-->
<!--                        <textarea :disabled="isDataUpdating"-->
<!--                                  @change="saveData"-->
<!--                                  placeholder="Ваш комментарий"-->
<!--                                  id="project_projectSmeta_motivation"-->
<!--                        ></textarea>-->
<!--                    </div>-->
                    <div class="columns your_score_text_footer">
                        <div class="column your_score_text_footer_col1">
                            <div class="as_favorite">Отметить проект как фаворит
                                <svg v-if="project.is_favorite" @click="toggleFavorite" width="22" height="20"
                                     viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.71272 12.3473L0.551444 7.918C0.501111 7.87189 0.490867 7.81361 0.50745 7.7654L0.508 7.76379C0.525296 7.71293 0.580365 7.65779 0.668371 7.64655L7.57747 6.94709L7.85963 6.91852L7.97991 6.6617L10.8159 0.606292L10.8162 0.605644C10.8416 0.55124 10.9088 0.5 11 0.5C11.0912 0.5 11.1584 0.551248 11.1838 0.605626L11.1842 0.606549L14.0202 6.65303L14.1406 6.90962L14.4225 6.93816L21.3316 7.63762C21.4197 7.64887 21.4747 7.70401 21.492 7.75483L21.4927 7.75701C21.5092 7.80466 21.4986 7.86462 21.4464 7.91107L21.2792 8.05961L21.2791 8.06358L16.2944 12.3475L16.0671 12.5429L16.1323 12.8355L17.5749 19.3081C17.575 19.3082 17.575 19.3082 17.575 19.3083C17.5856 19.3569 17.5684 19.4188 17.5057 19.4621L17.7899 19.8735L17.506 19.4619C17.4397 19.5077 17.3464 19.5131 17.2736 19.4733L17.2735 19.4732L11.2398 16.1756L10.9998 16.0445L10.76 16.1757L4.73382 19.4733C4.66172 19.5127 4.56849 19.5081 4.50062 19.462C4.4391 19.4188 4.42186 19.357 4.4324 19.3085C4.43243 19.3083 4.43246 19.3082 4.43249 19.3081L5.87513 12.8355L5.94039 12.5426L5.71272 12.3473Z"
                                          stroke="#1D232D" stroke-opacity="0.5"/>
                                </svg>
                                <svg v-else @click="toggleFavorite" width="22" height="20" viewBox="0 0 22 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M21.7784 8.29378L16.6203 12.7267L18.0632 19.2004C18.1196 19.4561 18.0125 19.7198 17.7899 19.8735C17.5682 20.0264 17.2723 20.0425 17.0337 19.912L11 16.6144L4.97376 19.912C4.73516 20.0425 4.43925 20.0264 4.21663 19.8735C3.99494 19.7198 3.88785 19.4561 3.94422 19.2004L5.3871 12.7267L0.221564 8.29378C0.0233547 8.11768 -0.0499151 7.84861 0.0346285 7.60279C0.118234 7.35697 0.344633 7.18085 0.613275 7.14957L7.52711 6.44963L10.3631 0.394227C10.4749 0.154652 10.7248 0 11 0C11.2752 0 11.5251 0.154647 11.6369 0.394227L14.4729 6.44071L21.3867 7.14064C21.6554 7.17193 21.8818 7.34803 21.9654 7.59387C22.0499 7.8388 21.9766 8.10876 21.7784 8.28486L21.7784 8.29378Z"
                                          fill="url(#paint0_linear_2218_40)"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_2218_40" x1="0" y1="0" x2="22.7793" y2="0.930898"
                                                        gradientUnits="userSpaceOnUse">
                                            <stop offset="0.0001" stop-color="#F7C100"/>
                                            <stop offset="1" stop-color="#F69400"/>
                                        </linearGradient>
                                    </defs>
                                </svg>

                            </div>
                        </div>
                        <div class="column your_score_text_footer_col2">
                            <div>
                                <button :disabled="isDataUpdating" class="button4" >Отправить</button>
                            </div>
                        </div>

                    </div>
                </div>
            </template>

            <Modal
                    v-model:visible="modal_visible"
                    :footer="null"
                    :title="null"
            >Нужно проставить все оценки
            </Modal>

            <Modal
                    v-model:visible="modal_success"
                    :footer="null"
                    :title="null"
            >Спасибо за оценку
            </Modal>
				</template>
				<template v-else>
            <Spin></Spin>
				</template>


    </div>
</template>

<style scoped>
.criterions__wrapper {
    /**/
}
.scores_box {
    border: 2px solid #F7C100;
    margin-bottom: 10px;
}
</style>